export function isEqualById(object1, object2): boolean {
    return isEqual(object1, object2, 'id');
}

export function isEqualByFieldId(object1, object2): boolean {
    return isEqual(object1, object2, 'fieldId');
}

export function isEqualByDepotId(object1, object2): boolean {
    return isEqual(object1, object2, 'depotId');
}

function isEqual(object1: any, object2: any, field: string): boolean {
    if (!object1 || !object2) return false;
    if (!object1?.[field] || !object2?.[field]) console.error(`No field: ${field} to compare.`);
    return object1[field] === object2[field];
}

export function naturalComparator(l1: string, l2: string): number {
  if (l1 === l2) return 0;
  let i = 0;
  const rx = /(\.\d+)|(\d+(\.\d+)?)|([^\d.]+)|(\.\D+)|(\.$)/g;
  const a: any = l1.toLowerCase().match(rx);
  const b: any = l2.toLowerCase().match(rx);
  while (i < a.length) {
    if (!b[i]) return 1;
    const a1 = a[i];
    const b1 = b[i++];
    if (a1 !== b1) {
      const n = a1 - b1;
      if (!isNaN(n)) return n;
      return a1 > b1 ? 1 : -1;
    }
  }
  return b[i] ? -1 : 0;
}
